declare global {
  interface Window {
    pintrk?: {
      (...args: unknown[]): void
      queue: unknown[][]
      version: string
    }
  }
}

// Ported from Pinterest's official base tag (https://ads.pinterest.com), typed
// and split out instead of injecting a raw eval'd snippet string.
function injectPixel(pixelId: string) {
  if (window.pintrk)
    return

  const pintrk: NonNullable<Window['pintrk']> = ((...args: unknown[]) => pintrk.queue.push(args)) as any
  pintrk.queue = []
  pintrk.version = '3.0'
  window.pintrk = pintrk

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://s.pinimg.com/ct/core.js'
  const firstScript = document.getElementsByTagName('script')[0]
  firstScript?.parentNode?.insertBefore(script, firstScript)

  window.pintrk('load', pixelId)
  window.pintrk('page')
}

export default defineNuxtPlugin((nuxtApp) => {
  // `pinterestPixel` is only declared in apps that opt in (see apps/exalted.com/app/config/runtime.ts),
  // so it's untyped for every other app extending this layer — cast like the Meta Pixel plugin.
  const config = useRuntimeConfig() as any
  // Nitro's runtime env override runs values through `destr`, so a numeric
  // pinterest tag id arrives as a number — coerce to string for pintrk('load').
  const pixelId: string | number | undefined = config.public?.pinterestPixelId
  if (!pixelId)
    return

  nuxtApp.hook('app:mounted', () => {
    injectPixel(String(pixelId))

    const router = useRouter()
    router.afterEach(() => nextTick(() => window.pintrk?.('page')))
  })
})
